
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import {
ListItemIcon, ListItemText, Menu,
    Tooltip
} from "@mui/material";

// App Imports

import {
    deleteDataPointAttribute,
    getAllDataPointAttributes,
} from "./DataPointAttributeClient";
import {changeDataPointAttribute} from "./dataPointAttributeSlice";
import DataPointAttributeDrawer from "../DataPointAttribute/DataPointAttributeDrawer";
import CustomFooter from "../CommonComponents/GridCustomFooter";
import {changeCrudSnackbar} from "../CommonComponents/crudSnackbarSlice";
import CrudSnackbar from "../CommonComponents/CrudSnackbar";
import {createNewDataSet} from "../Contract/ContractClient";
import {executeExpression} from "../ContractDataPoint/ContractDataPointClient";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddFiltersExportToolbar from "../CommonComponents/AddFiltersExportToolbar";
import {DataPointXrefGridColumns} from "../DataPointXref/DataPointXrefGridColumns";
import {changeDataPointXref} from "../DataPointXref/dataPointXrefSlice";
import {DataPointAttributeGridColumns} from "./DataPointAttributeGridColumns";
import {getAllDataPointValues} from "../DataPointValue/DataPointValueClient";
import {changeContractDataPoint} from "../ContractDataPoint/contractDataPointSlice";
import DpInfoDialogue from "../DataPoint/Info/DpInfoDialogue";
import DpaInfoDialogue from "./Info/DPaInfoDialogue";


// main function
export default function DataPointAttributeGrid() {

    // ****************** BEGIN STATES ****************************

    const [dataPointAttributes, setDataPointAttributes] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showCRUD, setShowCRUD] = useState(true);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [dpaInfoOpen, setDpaInfoOpen] = useState(false);


    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorDataPointAttributeId = useSelector((state) => state.dataPointAttributeSlc.value.id);
    const selectorDrawerState = useSelector((state) => state.dataPointAttributeSlc.value.dpaDrawerState);

    const dispatchData = useDispatch();

    const selectorDpaGridRefresh = useSelector(state => state.dataPointAttributeSlc.value.dpaGridRefresh);


    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************



    const fetchDataPointAttributes = React.useCallback(() => {
        return getAllDataPointAttributes()

            .then(data => {
                console.log(data);
                setDataPointAttributes(data);
            });
    }, []);

    //
    // useEffect(() => {
    //     fetchDataPointAttributes();
    //     dispatchData(changeDataPointAttribute({dpaGridRefresh: false}));
    // }, [useSelector((state) => state.dataPointAttributeSlc.value.dpaGridRefresh)===true]);
    //

    useEffect(() => {
        if (!selectorDpaGridRefresh) return;

        fetchDataPointAttributes().finally(() => {
            dispatchData(changeDataPointAttribute({
                dpaGridRefresh: false
            }));
        });
    }, [selectorDpaGridRefresh, fetchDataPointAttributes, dispatchData]);


    useEffect(() => {
        fetchDataPointAttributes();
    }, [fetchDataPointAttributes]);



    const [categoryDropdown, setCategoryDropdown] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState(null);

    const fetchDataPointValuesForDropdowns = () =>
        getAllDataPointValues()

            .then(data => {
                console.log(data);
                // setItems(data.sort((a, b) => a.name > b.name ? 1 : -1) );
                // setCategoryDropdown(data.filter(data => data.dataPointId ===  11785));
                setCategoryDropdown([
                    { name: null },   // or null, depending on your schema
                    ...data.filter(d => d.dataPointId === 11785)
                ]);


            })
    useEffect(() => {
        console.log("This is for the dropdown2...");
        fetchDataPointValuesForDropdowns();
    }, []);


    const handleCategoryChange = (categoryEvent) => {
        setSelectedCategory(categoryEvent.target.value);
        dispatchData(changeDataPointAttribute({category: categoryEvent.target.value}));
        console.log("This is for the selected Category");
        console.log(categoryEvent.target.value);
    };

    // ****************** END FETCH ****************************


    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeDataPointAttribute({id: null, mcode: null, name: null, description: null,
            status: null,category: null,
            dpaDrawerState: true, dpaDrawerMode: "Add"}));
    };

    const removeDataPointAttribute = () => {
        deleteDataPointAttribute(selectorDataPointAttributeId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeDataPointAttribute({dpaGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }


    // ****************** END CRUD ***********************************


    const handleClickedRow = (dataPointAttributes) => {

        console.log('Attribute data from clicked row');
        console.log(dataPointAttributes);
        dispatchData(changeDataPointAttribute({id: dataPointAttributes.id,
            mcode: dataPointAttributes.mcode, name: dataPointAttributes.name,
            description: dataPointAttributes.description,status:dataPointAttributes.status, category: dataPointAttributes.category}));
    };


    const handleDpaInfo = () => {
        setDpaInfoOpen(true);
    };

    const handleCloseDpaInfo = () => {
        setDpaInfoOpen(false);
    };



    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 70, pt: 1, pl: 3}}>
                <Tooltip enterDelay={1000} title={"Click for information."}>
                <h3
                    style={{cursor:'pointer'}}   onClick={() => handleDpaInfo()}
                >Data Point Attributes</h3>
                </Tooltip>
            </Box>
            <DpaInfoDialogue
                open={dpaInfoOpen}
                onClose={handleCloseDpaInfo}
            />
            {selectorDrawerState && <DataPointAttributeDrawer
                handleCategoryChange={handleCategoryChange}
                categoryDropdown={categoryDropdown}
            />}
            {/*}*/}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"DataPointAttributes"}
                rows={dataPointAttributes}
                disableDensitySelector={true}
                disableColumnSelector={true}
                onRowClick = {(dataPointAttributes)=>handleClickedRow(dataPointAttributes.row)}
                columns={DataPointAttributeGridColumns({
                    hideActions, handleCategoryChange,categoryDropdown,
                    onEdit: () => dispatchData(changeDataPointAttribute({ dpaDrawerState: true, dpaDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeDataPointAttribute({ dpaDrawerState: true, dpaDrawerMode: "Clone" })),
                    onDelete: removeDataPointAttribute
                })}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={dataPointAttribute => dataPointAttribute.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
        </div>
    );

    // ****************** END RETURN ****************************

}

